import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  GiftCardDetailPage,
  giftCardQueryOptions,
  giftCardTransactionsQueryOptions,
} from '@/features/gift-cards';

export const Route = createFileRoute('/_authed/_active/s/$storeId/gift-cards/$giftCardId')({
  staticData: { tours: ['gift-cards.detail'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'gift_cards.read');
  },
  loader: async ({ context, params }) => {
    const [card] = await Promise.all([
      context.queryClient.query({
        ...giftCardQueryOptions(params.storeId, params.giftCardId),
        staleTime: 'static',
      }),
      context.queryClient
        .query({
          ...giftCardTransactionsQueryOptions(params.storeId, params.giftCardId),
          staleTime: 'static',
        })
        .catch(() => undefined),
    ]);
    return { crumb: `•••• ${card.last4}` };
  },
  component: GiftCardDetailPage,
});
